{
	"actions_of": "Azioni per la domanda {{protocol}}",
	"check_in": "Entrato il {{date}}",
	"check_in_command": {
		"action": "Conferma ingresso",
		"before_proposal": "La data non può essere prima della proposta della camera.",
		"blocked": {
			"offer_not_accepted": "L'offerta non è più accettata.",
			"room_not_proposed": "Prima proponi la camera.",
			"verification_not_compliant": "Prima la verifica dei documenti deve essere conforme."
		},
		"confirm": "Conferma",
		"date": "Entrato il",
		"description": "Il giorno in cui lo studente è entrato nella camera proposta. L'ingresso conta anche per la quota DSU.",
		"done": "Ingresso confermato.",
		"future": "La data non può essere nel futuro.",
		"title": "Conferma l'ingresso"
	},
	"columns": {
		"actions": "Azioni",
		"check_in": "Ingresso",
		"name": "Studente",
		"preference": "Preferenza",
		"protocol": "Protocollo",
		"quota": "Quota",
		"room": "Camera",
		"verification": "Verifica"
	},
	"counts": {
		"double": "Doppie",
		"equipped": "di cui attrezzate {{used}} su {{total}}",
		"quota": {
			"q30": "Quota 30%",
			"q70": "Quota 70%"
		},
		"single": "Singole",
		"sites": "Sedi",
		"title": "Posti",
		"used": "{{used}} su {{total}}"
	},
	"empty": "Nessuno ha ancora accettato un'offerta.",
	"empty_filtered": "Nessuno in questo stato.",
	"equipped_priority": "Posto attrezzato, con la priorità per la disabilità",
	"error": "Non è stato possibile caricare gli ingressi. Ricarica la pagina.",
	"fact": {
		"action": "Registra un fatto",
		"cause": "Fatto",
		"confirm": "Registra",
		"contract_hint": "Solo prima dell'ingresso: chi è entrato ha firmato il contratto.",
		"date": "Data del fatto",
		"description": "Il posto torna libero e passa al successivo in graduatoria, e lo studente riceve un'email con la causa. Il fatto non si annulla.",
		"done": "Fatto registrato: il posto passa al successivo.",
		"line": "{{cause}}, il {{date}}",
		"note": "Nota",
		"note_hint": "Facoltativa.",
		"out_of_range": "La data non può essere nel futuro né prima dell'accettazione.",
		"proof_hint": "La comunicazione dello studente, o la prova del termine scaduto.",
		"title": "Registra un fatto dopo l'accettazione"
	},
	"filter": "Stato",
	"intro": "Chi ha accettato un'offerta, dalla verifica dei documenti all'ingresso: apri la verifica dal nome, poi proponi la camera e la sede e registra l'ingresso. Il gestionale tiene il conto dei posti di ogni quota e di ogni sede.",
	"limit": {
		"equipped_required": "Il posto è stato assegnato con la priorità per la disabilità: serve una camera attrezzata.",
		"equipped_reserved": "Le camere attrezzate rimaste servono agli studenti con la priorità per la disabilità che non hanno ancora una camera.",
		"quota": "La {{quota}} non ha più camere {{type}} libere: sono {{available}} in tutto.",
		"site": "La sede {{site}} non ha più camere {{type}} libere.",
		"site_equipped": "La sede {{site}} non ha più camere {{type}} attrezzate libere.",
		"site_ordinary": "La sede {{site}} non ha più camere {{type}} non attrezzate libere: sono {{available}} in tutto. Scegli «Camera attrezzata» o un'altra sede."
	},
	"not_given": "Non indicato",
	"page_title": "Ingressi",
	"preference": {
		"double": "Doppia",
		"none": "Nessuna preferenza",
		"single": "Singola"
	},
	"propose": {
		"action": "Proponi camera",
		"again": "Cambia camera",
		"confirm": "Proponi",
		"description": "Lo studente riceve un'email con la camera, la sede e le istruzioni per firmare il contratto.",
		"done": "Camera proposta: lo studente riceve l'email.",
		"equipped": "Camera attrezzata",
		"equipped_free": "Attrezzate libere nella sede: {{free}}",
		"equipped_required": "Obbligatoria: il posto è stato assegnato con la priorità per la disabilità.",
		"free": "Liberi: {{quotaFree}} nella {{quota}}, {{siteFree}} nella sede",
		"preference_differs": "Lo studente preferiva: {{preference}}. Puoi comunque proporre questa camera.",
		"room_type": "Tipo di camera",
		"site": "Sede",
		"title": "Proponi camera e sede"
	},
	"quota": {
		"q30": "Quota 30%",
		"q70": "Quota 70%"
	},
	"quota_inline": {
		"q30": "quota 30%",
		"q70": "quota 70%"
	},
	"room": {
		"double": "Camera doppia",
		"equipped": "attrezzata",
		"none": "Da proporre",
		"single": "Camera singola"
	},
	"search_placeholder": "Cerca per protocollo o nome",
	"state": {
		"checked_in": "Entrato",
		"forfeited": "Decaduto",
		"room_proposed": "Camera proposta",
		"to_propose": "Da proporre"
	},
	"type_plural": {
		"double": "doppie",
		"single": "singole"
	},
	"verification": {
		"compliant": "Conforme",
		"excluded": "Esclusa",
		"none": "Non aperta",
		"pending": "In attesa",
		"to_check": "Da controllare: {{items}}"
	},
	"verification_filter": "Verifica"
}
